import { IconProps } from './type';

export const ICReport: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="28" y="16" width="72" height="96" rx="14" fill="#4f4b5c" />
            <rect x="42" y="32" width="44" height="8" rx="4" fill="#FF7A59" />
            <rect x="42" y="76" width="10" height="18" rx="5" fill="#FF7A59" />
            <rect x="58" y="62" width="10" height="32" rx="5" fill="#FF7A59" />
            <rect x="74" y="48" width="10" height="46" rx="5" fill="#FF7A59" />
            <rect x="42" y="48" width="24" height="6" rx="3" fill="#FF7A59" />
        </svg>
    );
};
